import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable, catchError, map, of } from 'rxjs';

import { EnvironmentConfig } from '../config/environment.config';
import { OptionsLibrarySet } from '../models/options-library/options-library-form.interface';

@Injectable({ providedIn: 'root' })
export class OptionsLibraryService {
  constructor(
    @Inject('environment') private environment: EnvironmentConfig,
    private http: HttpClient
  ) {}

  fetchOptionsSets(): Observable<OptionsLibrarySet[]> {
    return this.http.get<OptionsLibrarySet[]>(`${this.environment.endPoint}library/questions/content`).pipe(catchError(() => of([])));
  }

  saveOptionsSet(set: OptionsLibrarySet): Observable<boolean> {
    return this.http.post<OptionsLibrarySet>(`${this.environment.endPoint}library/questions/content`, set).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  editOptionsSet(set: OptionsLibrarySet): Observable<boolean> {
    return this.http.put<OptionsLibrarySet>(`${this.environment.endPoint}library/questions/content/${set.id}`, set).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }

  deleteOptionsSet(id: string): Observable<boolean> {
    return this.http.delete<OptionsLibrarySet>(`${this.environment.endPoint}library/questions/content/${id}`).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}
